var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoftwareHealthIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SoftwareHealthIcon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_856",
    "data-name": "Rectangle 856",
    width: 30,
    height: 30,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(1.82 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M21.826,7.967,18.734,6.55l3.093-1.417L23.225,2l1.4,3.133L27.717,6.55,24.624,7.967l-1.4,3.133Zm4.966,7.969-1-2.236-1,2.236L22.584,16.95l2.207,1.014,1,2.236,1-2.236L29,16.95Zm-6.468,2.145,2.49,1.911-3.208,5.629L16.732,24.4a8.535,8.535,0,0,1-.821.481L15.525,28H9.109l-.385-3.133a7.53,7.53,0,0,1-.821-.481L5.028,25.608,1.82,19.979l2.49-1.911C4.3,17.925,4.3,17.756,4.3,17.6s0-.325.013-.481L1.82,15.208,5.028,9.579,7.9,10.8a8.535,8.535,0,0,1,.821-.481L9.109,7.2h6.416l.385,3.133a7.53,7.53,0,0,1,.821.481l2.875-1.222,3.208,5.629-2.49,1.911c.013.156.013.312.013.481S20.338,17.925,20.325,18.081ZM16.167,17.6a3.85,3.85,0,1,0-3.85,3.9A3.87,3.87,0,0,0,16.167,17.6Z",
    transform: "translate(-1.82 -2)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareHealthIcon);
export default __webpack_public_path__ + "static/media/SoftwareHealthIcon.835e30d9e4c2eb6c64617e22602445f1.svg";
export { ForwardRef as ReactComponent };